<template>
  <v-layout fluid row wrap>
    <v-flex sm12>
      <h2 class="headline">Show password field</h2>
      <v-form>
        <v-checkbox
          label="Show password field"
          v-model="globalSetting.allowPasswordOnRegistration"
        ></v-checkbox>
        <v-btn class="green white--text" @click="submitUpdate">submit</v-btn>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  export default {
    name: 'passwordRegistrationSettings',
    data () {
      return {
        globalSetting: {}
      }
    },
    computed: {
      ...mapGetters(['getSettings'])
    },
    methods: {
      ...mapActions({
        fetchSettings: 'fetchGeneralSettings',
        putAttendeePassword: 'putAttendeePassword'
      }),
      submitUpdate () {
        this.putAttendeePassword({ allowPasswordOnRegistration: this.globalSetting.allowPasswordOnRegistration })
      }
    },
    async mounted () {
      if (!this.getSettings) {
        await this.fetchSettings()
      }
      this.globalSetting = this.getSettings.globalSetting
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Registration/Settings/passwordSettings.vue